export const NEW_ADMIN_ALERT_URL = '/admin_alert/new'
